import { createActions } from 'utils/actions';

/**
 * Redux actions to fetch a handbook's Summary of Changes
 *
 * @type {Object}
 */
export const fetchTemplatesSummaryOfChanges = createActions(
    'handbooksTemplates',
    'FETCH_TEMPLATES_SUMMARY_OF_CHANGES',
    {
        asPromise: true,
    }
);

/**
 * Redux actions to accept a handbook's Policy Summary of Changes
 *
 * @type {Object}
 */
export const acceptTemplatesPolicySummaryOfChanges = createActions(
    'handbooksTemplates',
    'ACCEPT_TEMPLATES_POLICY_SUMMARY_OF_CHANGES',
    {
        asPromise: true,
    }
);

/**
 * Redux actions to send handbook reminders to admins
 *
 * @type {Object}
 */
export const sendHandbookReminder = createActions('handbooksTemplates', 'SEND_HANDBOOK_REMINDER', {
    asPromise: true,
});

/**
 * Redux actions to fetch linked handbooks by policy
 *
 * @type {Object}
 */
export const fetchLinkedHandbooksByPolicy = createActions(
    'handbooksTemplates',
    'FETCH_LINKED_HANDBOOKS_BY_POLICY',
    {
        asPromise: true,
    }
);
